import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

interface GlassCardProps extends BoxProps {
  children: React.ReactNode;
  baseColor?: string;
}

// Helper function to lighten a hex color
const lightenColor = (hex: string, percent: number): string => {
  const num = parseInt(hex.replace('#', ''), 16);
  const amt = Math.round(2.55 * percent);
  const R = (num >> 16) + amt;
  const G = (num >> 8 & 0x00FF) + amt;
  const B = (num & 0x0000FF) + amt;
  return '#' + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 +
    (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 +
    (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1);
};

const GlassCard: React.FC<GlassCardProps> = ({ children, baseColor, ...props }) => {
  // Default to the current gray-green theme if no baseColor provided
  const defaultGradient = "linear-gradient(145deg, rgba(26, 31, 26, 0.75) 0%, rgba(52, 73, 94, 1.00) 50%, rgba(26, 31, 26, 0.50) 100%)";
  
  // If baseColor is provided, create a gradient based on it
  const gradient = baseColor 
    ? `linear-gradient(145deg, ${baseColor}80 0%, ${lightenColor(baseColor, 20)}c0 50%, ${baseColor}30 100%)`
    : defaultGradient;

  return (
    <Box
      background={gradient}
      borderRadius="lg"
      borderWidth="1px"
      borderColor="gray.500"
      backdropFilter="blur(10px)"
      boxShadow="0 2px 8px rgba(0, 0, 0, 0.15)"
      position="relative"
      {...props}
    >
      {children}
    </Box>
  );
};

export default GlassCard; 